// extracted by mini-css-extract-plugin
export default {"container":"ConfirmPopoverContent_container__VXx1o","contentWrapper":"ConfirmPopoverContent_contentWrapper__p2ATo","buttonWrapper":"ConfirmPopoverContent_buttonWrapper__R4Rcm"};